/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import _cloneDeep from 'lodash/cloneDeep';
import { Analytics } from '../../../../analytics/sendAnalyticsEvent';
import { buildCategoryEventName } from '../utils/buildCategoryEventName';
import { ANALYTICS_PROCESS_PRE_IGNITION_EVENTS_DELAY } from '../../../../constants';

export default (set, get, payload) => {
  const { filterGroups, delayed } = payload;
  function transformFilterGroups(groupedFilters) {
    if (!groupedFilters || typeof groupedFilters !== 'object') return { filter: [] };

    return {
      filter: Object.entries(groupedFilters).map(([key, values]) => (Array.isArray(values)
        ? values.map((value) => ({
          type: key.toLowerCase(),
          value: value.toLowerCase(),
          filterType: 'primary'
        }))
        : [])
      )
    };
  }

  const { category, eventInfo } = buildCategoryEventName('browse', 'filter by');

  const event = {
    category,
    eventInfo,
    displayAttributes: {
      productsAvailability: 'all products',
      sortBy: 'default',
      viewType: 'grid',
      pageNumber: '1',
    },
    filter: transformFilterGroups(filterGroups).filter
  };
  const eventClone = _cloneDeep(event);
  set(
    produce(get(), (draft) => {
      if (!draft.digitalData) {
        draft.digitalData = { event: [] };
      }

      draft.digitalData.event.push(event);
    }),
    false,
    { type: 'COLLECTION_REFINEMENTS_FILTERS_EVENT' }
  );
  if (delayed) {
    setTimeout(() => {
      Analytics.sendAnalyticsEvent(eventClone);
    }, ANALYTICS_PROCESS_PRE_IGNITION_EVENTS_DELAY);
  } else {
    Analytics.sendAnalyticsEvent(eventClone);
  }
};